import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
// import { auth, database } from '../firebase';
// import { collection, getDocs } from 'firebase/firestore';

import {
  objectIsEmpty,
  resultsLength,
} from '../utils/validate';
import {
  formatDate,
  formatDateTimeToYear,
  formatDateRange,
  formatDateTime,
} from '../utils/date';
import { getFilters } from '../utils/filters';
import { OPBookLabel } from '../utils/format';
import { MailchimpSignupForm } from './mailchimpSignupForm/MailchimpSignupForm';
import {
  IconChevronDown,
  IconChevronUp,
  IconDownload,
  IconSortDynamic,
} from './icons';
import { DateRangeSelect, DateRangeButton } from './dateRangeSelect/DateRangeSelect';
import { ToggleFilterButton } from './toggleFilterButton/ToggleFilterButton';

const json = require('../data-202604.json');

const Main = ({
  checkedStorage,
  showPopup,
  setHasSubmitted,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const [patentData, setPatentData] = useState();
  const [patentDataFiltered, setPatentDataFiltered] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    drug: [],
    drugArray: [],
    assignee: [],
    assigneeArray: [],
    conditionsTreated: [],
    conditionsTreatedArray: [],
    dateFiled: [],
    dateExpiry: [],
    patentType: [],
    patentTypeArray: [],
    statusFdaApproval: [],
    statusOPBook: [],
    status: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
    drug: [],
    drugArray: [],
    assignee: [],
    assigneeArray: [],
    conditionsTreated: [],
    conditionsTreatedArray: [],
    dateFiled: [],
    dateExpiry: [],
    patentType: [],
    patentTypeArray: [],
    statusFdaApproval: [],
    statusOPBook: [],
    patentNo: '',
    status: [],
  });

  const [filterToggleOpen, setFilterToggleOpen] = useState({
    group1: false,
    group2: false,
    group3: false,
    group4: false,
    group5: false,
  });

  const [didFetch, setDidFetch] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [sortBy, setSortBy] = useState(['drug', 'ASC']);

  // Dates
  const [filedDateRange, setFiledRangeDate] = useState([]);
  const [filedDateRangeOpen, setFiledDateRangeOpen] = useState(false);

  const [expiryDateRange, setExpiryRangeDate] = useState([]);
  const [expiryDateRangeOpen, setExpiryDateRangeOpen] = useState(false);

  // let navigate = useNavigate();
  // const { pathname } = window.location;

  // Get patents from database from firestore
  // TODO remove
  // async function fetchData(auth, db) {
  //   const patentsCol = collection(db, 'patents');
  //   const patentsSnapshot = await getDocs(patentsCol);
  //   if (patentsSnapshot) {
  //     const patentsList = patentsSnapshot.docs.map(doc => doc.data());
  //     setPatentData(patentsList);
  //     getFilters(patentsList);
  //   }
  // }

  // Apply filters
  const filterData = (data, selectedFilters) => {
    const filterKeys = Object.keys(selectedFilters);
    // applyParams(selectedFilters);

    return data.filter(entry => {
      return filterKeys.every(key => {
        if (!selectedFilters[key].length) return true;

        // Loops again if entry[key] is an array (for material attribute).
        if (Array.isArray(entry[key])) {
          return entry[key].some(keyEle => selectedFilters[key].includes(keyEle));
        }

        if (key === 'patentNo') {
          return selectedFilters[key].includes(entry[key]) || entry[key].includes(selectedFilters[key])
        }

        if (key === 'dateExpiry') {
          const rangeStart = new Date(selectedFilters.dateExpiry[0]);
          const rangeEnd = new Date(selectedFilters.dateExpiry[1]);
          // old 2022 db values had __time__ key
          const dateString = entry.dateExpiry?.__time__ || entry.dateExpiry; // fallback if not nested
          const entryDate = new Date(dateString);

          return entryDate >= rangeStart && entryDate <= rangeEnd;
        }

        if (key === 'dateFiled') {
          const rangeStart = new Date(selectedFilters.dateFiled[0]);
          const rangeEnd = new Date(selectedFilters.dateFiled[1]);
          // old 2022 db values had __time__ key
          const dateString = entry.dateFile?.__time__ || entry.dateFile; // fallback if not nested
          const entryDate = new Date(dateString);

          return entryDate >= rangeStart && entryDate <= rangeEnd;
        }

        return selectedFilters[key].includes(entry[key]);
      });
    });
  };

  const clearFilters = () => {
    setSelectedFilters({
      drug: [],
      drugArray: [],
      assignee: [],
      assigneeArray: [],
      conditionsTreated: [],
      conditionsTreatedArray: [],
      dateFiled: [],
      dateExpiry: [],
      patentType: [],
      patentTypeArray: [],
      statusFdaApproval: [],
      statusOPBook: [],
    })
    setSearchParams('');
  }

  useEffect(() => {
    if (!didFetch) {
      setDidFetch(true);

      // fetch from firebase
      // fetchData(auth, database);

      // fetch from local json file
      const data = Object.values(json.data);
      setPatentData(data);

      const filters = getFilters(data);
      setFilters(filters);
    }

    if (patentData && selectedFilters && sortBy.length === 0) {
      const filteredResults = filterData(patentData, selectedFilters)
        .sort((a, b) => {
          return (a.drug < b.drug) ? -1 : (a.drug > b.drug) ? 1 : 0;
        });
      setPatentDataFiltered(filteredResults);
    }

    // Sorting
    if (patentData && sortBy.length > 0 && selectedFilters) {
      const key = sortBy[0];
      const dir = sortBy[1];

      let filteredResultsASC;
      let filteredResultsDESC;

      // if (key === 'dateStringFile' || key === 'dateStringExpiry') {
      // filteredResultsASC = filterData(patentData, selectedFilters)
      //   .sort((a, b) => {
      //     return (new Date(a[key]) < new Date(b[key])) ? -1 : (new Date(a[key]) > new Date(b[key])) ? 1 : 0;
      //   });

      // filteredResultsDESC = filterData(patentData, selectedFilters)
      //   .sort((a, b) => {
      //     return (new Date(a[key]) < new Date(b[key])) ? 1 : (new Date(a[key]) > new Date(b[key])) ? -1 : 0;
      //   });
      // }

      // TODO fix 'dateExpiry' sorting
      if (key === 'dateFile' || key === 'dateExpiry') {
        filteredResultsASC = filterData(patentData, selectedFilters)
          .sort((a, b) => {
            const itemA = (a[key].__time__ && a[key].__time__.split('T')[0]) || '';
            const itemB = (b[key].__time__ && b[key].__time__.split('T')[0]) || '';
            return (itemA < itemB) ? -1 : (itemA > itemB) ? 1 : 0;
          });

        filteredResultsDESC = filterData(patentData, selectedFilters)
          .sort((a, b) => {
            const itemA = (a[key].__time__ && a[key].__time__.split('T')[0]) || '';
            const itemB = (b[key].__time__ && b[key].__time__.split('T')[0]) || '';
            return (itemA < itemB) ? 1 : (itemA > itemB) ? -1 : 0;
          });
      } else {
        filteredResultsASC = filterData(patentData, selectedFilters)
          .sort((a, b) => {
            return (a[key] < b[key]) ? -1 : (a[key] > b[key]) ? 1 : 0;
          });

        filteredResultsDESC = filterData(patentData, selectedFilters)
          .sort((a, b) => {
            return (a[key] < b[key]) ? 1 : (a[key] > b[key]) ? -1 : 0;
          });
      }

      if ((dir === 'ASC') && filteredResultsASC) {
        setPatentDataFiltered(filteredResultsASC);
      }
      if ((dir === 'DESC') && filteredResultsDESC) {
        setPatentDataFiltered(filteredResultsDESC);
      }
    }

  }, [patentData, selectedFilters, sortBy, didFetch]);

  useEffect(() => {
    const drug = searchParams.get('drug') ? searchParams.get('drug') : '';

    if (drug && filters?.drug?.includes(drug)) {
      applyFilters('drug', drug)
    }

  }, [filters]);

  useEffect(() => {
    const disableOverlay = searchParams.get('disableOverlay') || '';

    if (disableOverlay) {
      localStorage.setItem('emailCaptured', 'true');
    }
  });

  // function applyParams(selectedFilters) {
  //   if (selectedFilters) {
  //     console.log('selectedFilters-', selectedFilters)

  //     const queryString = Object.entries(selectedFilters)
  //       .map(([k, v]) => {
  //         if (Object.values(v).length > 0) {
  //           return `${k}=${Object.values(v)}`
  //         }
  //       })
  //       .join('&');

  //     // const params = createSearchParams(queryString);
  //     setSearchParams(queryString.toString());
  //     // history.push({ '/', search: queryString.toString() });
  //     // navigate(`/?${queryString}`)
  
  //     // if (selectedFilters.drug.length && selectedFilters.drug.length == 1) {
  //     //   const drugName = selectedFilters.drug[0];
  //     //   navigate(`/drug/${drugName}`);
  //     // }
  //     // else {
  //     //   navigate('/');
  //     // }
  //   }
  // }

  // Apply filters
  function applyFilters(filter, item) {
    let copiedSelectedFilters = { ...selectedFilters };

    if (copiedSelectedFilters[filter]?.includes(item)) {
      const idx = copiedSelectedFilters[filter].findIndex(elem => elem === item);

      setSelectedFilters(selectedFilters => ({
        ...selectedFilters,
        [filter]: [
          ...copiedSelectedFilters[filter].slice(0, idx),
          ...copiedSelectedFilters[filter].slice(idx + 1),
        ]
      }));

    } else {
      const string = [item];
      setSelectedFilters(selectedFilters => ({
        ...selectedFilters,
        [filter]: [
          ...copiedSelectedFilters[filter],
          ...string
        ]
      }));
    }
  }

  function applyPatentNoFilter(patent) {
    setSelectedFilters(selectedFilters => ({
      ...selectedFilters,
      patentNo: patent,
    }));
  }

  function applyFiltersDate(filter, item) {
    setSelectedFilters(selectedFilters => ({
      ...selectedFilters,
      [filter]: item,
    }));
  }

  function toggleRow(idx) {
    const index = expandedRows.findIndex((id) => id === idx);
    if (index !== -1) {
      setExpandedRows([
        ...expandedRows.slice(0, index),
        ...expandedRows.slice(index + 1),
      ]);
    } else {
      setExpandedRows([
        ...expandedRows,
        idx,
      ])
    }
  }

  const onDateChange = (ranges) => {
    const { id, startDate, endDate } = ranges;
    const startDateFormatted = formatDate(startDate);
    const endDateFormatted = formatDate(endDate);

    if (id === 'filed') {
      setFiledRangeDate([startDateFormatted, endDateFormatted]);
      applyFiltersDate('dateFiled', [startDateFormatted, endDateFormatted])

      if (startDateFormatted !== endDateFormatted) {
        setFiledDateRangeOpen(false);
      } else if (startDate === '' && endDate === '') {
        setFiledDateRangeOpen(false);
      }
    }
    if (id === 'expiry') {
      setExpiryRangeDate([startDateFormatted, endDateFormatted]);
      applyFiltersDate('dateExpiry', [startDateFormatted, endDateFormatted])

      if (startDateFormatted !== endDateFormatted) {
        setExpiryDateRangeOpen(false);
      } else if (startDate === '' && endDate === '') {
        setExpiryDateRangeOpen(false);
      }
    }
    return ranges;
  }

  return (
    <div className={`Main ${checkedStorage && showPopup && 'subscribe-overlay'}`}>
      {showPopup && (
        <MailchimpSignupForm setHasSubmitted={setHasSubmitted} />
      )}

      <div className="container">
        <div className="filters-heading">
          <h3>Filter by:</h3>
          <button
            className={`btn btn-grey btn-clear ${objectIsEmpty(selectedFilters) && 'hidden'}`}
            onClick={() => clearFilters()}
          >
            Clear All Filters
          </button>
        </div>

        <div className="filters">
          <div className="row">
            <div className={`col filter-group ${filterToggleOpen.group1 ? 'open' : ''}`}>
              {isMobile ? (
                <ToggleFilterButton
                  text="Drug Name"
                  onClick={() => setFilterToggleOpen(prevState => ({
                    ...prevState,
                    group1: !prevState.group1,
                  }))}
                  isOpen={filterToggleOpen.group1}
                />
              ) : (
                <h4 className="toggle-filter">Drug Name</h4>
              )}
              <div className="filter-group-inner drug-name">
                {filters?.drugArray?.map((filter, idx) => (
                  <div className="fieldset" key={`f-drug-${idx}`}>
                    <input
                      type="checkbox"
                      id={`drug-${filter}`}
                      name={`drug-${filter}`}
                      onChange={() => applyFilters('drugArray', filter)}
                      checked={selectedFilters.drugArray.includes(filter)}
                    />
                    <label htmlFor={`drug-${filter}`}>{filter}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className={`col filter-group filter-group-multiple ${filterToggleOpen.group2 ? 'open' : ''}`}>
              {isMobile ? (
                <ToggleFilterButton
                  text="Patent/Publication Number"
                  textSecondary="Condition(s) Treated"
                  onClick={() => setFilterToggleOpen(prevState => ({
                    ...prevState,
                    group2: !prevState.group2,
                  }))}
                  isOpen={filterToggleOpen.group2}
                />
              ) : (
                <h4>Patent/Publication <br />Number</h4>
              )}
              <div className="filter-group-inner">
                <input
                  id="patentNoInput"
                  type="text"
                  name="patentNo"
                  value={(selectedFilters && selectedFilters.patentNo) || ''}
                  onChange={e => applyPatentNoFilter(e.target.value)}
                />
              </div>

              <h4>Condition(s) Treated</h4>
              <div className="filter-group-inner conditions-treated">
                {filters?.conditionsTreatedArray?.map((filter, idx) => (
                  <div className="fieldset" key={`f-conditionsTreated-${idx}`}>
                    <input
                      type="checkbox"
                      id={`conditionsTreated-${filter}`}
                      name={`conditionsTreated-${filter}`}
                      onChange={() => applyFilters('conditionsTreatedArray', filter)}
                      checked={selectedFilters.conditionsTreatedArray.includes(filter)}
                    />
                    <label htmlFor={`conditionsTreated-${filter}`}>{filter}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className={`col filter-group filter-group-multiple ${filterToggleOpen.group3 ? 'open' : ''}`}>
              {isMobile ? (
                <ToggleFilterButton
                  text="Assignee"
                  onClick={() => setFilterToggleOpen(prevState => ({
                    ...prevState,
                    group3: !prevState.group3,
                  }))}
                  isOpen={filterToggleOpen.group3}
                />
              ) : (
                <h4 className="toggle-filter">Assignee</h4>
              )}
              
              <div className="filter-group-inner">
                {filters?.assigneeArray?.map((filter, idx) => (
                  <div className="fieldset" key={`f-assignee-${idx}`}>
                    <input
                      type="checkbox"
                      id={`assignee-${filter}`}
                      name={`assignee-${filter}`}
                      onChange={() => applyFilters('assigneeArray', filter)}
                      checked={selectedFilters.assigneeArray.includes(filter)}
                    />
                    <label htmlFor={`assignee-${filter}`}>{filter}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className={`col filter-group filter-group-multiple ${filterToggleOpen.group4 ? 'open' : ''}`}>
              {isMobile ? (
                <ToggleFilterButton
                  text="Status"
                  textSecondary="Patent Type"
                  onClick={() => setFilterToggleOpen(prevState => ({
                    ...prevState,
                    group4: !prevState.group4,
                  }))}
                  isOpen={filterToggleOpen.group4}
                />
              ) : (
                <h4 className="toggle-filter">Status</h4>
              )}
              <div className="filter-group-inner">
                {filters?.status?.map((filter, idx) => (
                  <div className="fieldset" key={`f-status-${idx}`}>
                    <input
                      type="checkbox"
                      id={`status-${filter}`}
                      name={`status-${filter}`}
                      onChange={() => applyFilters('status', filter)}
                      checked={selectedFilters.status.includes(filter)}
                    />
                    <label htmlFor={`status-${filter}`}>
                      {filter}
                    </label>
                  </div>
                ))}
              </div>
   
              <h4>Patent Type</h4>
              <div className="filter-group-inner patent-type">
                {filters?.patentTypeArray && filters.patentTypeArray.map((filter, idx) => (
                  <div className="fieldset" key={`f-patentType-${idx}`}>
                    <input
                      type="checkbox"
                      id={`patentType-${filter}`}
                      name={`patentType-${filter}`}
                      onChange={() => applyFilters('patentTypeArray', filter)}
                      checked={selectedFilters.patentTypeArray.includes(filter)}
                    />
                    <label htmlFor={`patentType-${filter}`}>{filter}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className={`col filter-group filter-group-multiple ${filterToggleOpen.group5 ? 'open' : ''}`}>
              {isMobile ? (
                <>
                  <ToggleFilterButton
                    text={filterToggleOpen.group5 ? 'Filing Date' : 'Filing & Expiry Date'}
                    textSecondary="FDA Approval"
                    textTertiary="O/P Book"
                    onClick={() => setFilterToggleOpen(prevState => ({
                      ...prevState,
                      group5: !prevState.group5,
                    }))}
                    isOpen={filterToggleOpen.group5}
                  />
                </>
              ) : (
                <div className="filter-heading-container">
                  <h4 className="filter-heading date">Filing Date</h4>
                  <span
                    className={`clear-date ${selectedFilters.dateFiled[0] && selectedFilters.dateFiled[1] ? '' : 'hidden'}`}
                    onClick={() => applyFiltersDate('dateFiled', [])}>
                    Clear
                  </span>
                </div>
              )}
              <div className="filter-group-date">
                <div className="fieldset-date">
                  <div>
                    <div className="fieldset-date-input-wrap">
                      <input
                        type="text"
                        name="filedDateStart"
                        value={
                          selectedFilters.dateFiled && selectedFilters.dateFiled[0]
                            ? formatDateRange(selectedFilters.dateFiled[0])
                            : ''
                        }
                        disabled
                        aria-label="Filing Date Start"
                        placeholder="MM/DD/YYYY"
                      />
                      <span>–</span>
                      <input
                        type="text"
                        name="filedDateEnd"
                        value={
                          selectedFilters.dateFiled && selectedFilters.dateFiled[1]
                            ? formatDateRange(selectedFilters.dateFiled[1])
                            : ''
                        }
                        disabled
                        aria-label="Filing Date Start"
                        placeholder="MM/DD/YYYY"
                      />
                    </div>
                    <DateRangeButton
                      id="filed"
                      open={filedDateRangeOpen}
                      setOpen={setFiledDateRangeOpen}
                    />
                  </div>
                </div>
                {setFiledDateRangeOpen && (
                  <DateRangeSelect
                    id="filed"
                    onChange={onDateChange}
                    open={filedDateRangeOpen}
                    setOpen={setFiledDateRangeOpen}
                  />
                )}
                {isMobile && (<span
                  className={`clear-date ${selectedFilters.dateFiled[0] && selectedFilters.dateFiled[1] ? '' : 'hidden'}`}
                  onClick={() => applyFiltersDate('dateFiled', [])}>
                  Clear
                </span>)}
              </div>
                
            {isMobile ? (
              <h4 className="filter-heading date margin-t-2">Filing Date</h4>
            ) : (
              <div className="filter-heading-container">
                <h4 className="filter-heading date margin-t-2">Expiry Date</h4>
                <span
                  className={`clear-date ${selectedFilters.dateExpiry[0] && selectedFilters.dateExpiry[1] ? '' : 'hidden'}`}
                  onClick={() => applyFiltersDate('dateExpiry', [])}>
                  Clear
                </span>
              </div>
            )}

              <div className="filter-group-date">
                <div className="fieldset-date">
                  <div>
                    <div className="fieldset-date-input-wrap">
                      <input
                        type="text"
                        name="expiryDateStart"
                        value={
                          selectedFilters.dateExpiry && selectedFilters.dateExpiry[0]
                            ? formatDateRange(selectedFilters.dateExpiry[0])
                            : ''
                        }
                        disabled
                        aria-label="Expiry Date Start"
                        placeholder="MM/DD/YYYY"
                      />
                      <span>–</span>
                      <input
                        type="text"
                        name="expiryDateEnd"
                        value={selectedFilters.dateExpiry && selectedFilters.dateExpiry[1]
                          ? formatDateRange(selectedFilters.dateExpiry[1])
                          : ''
                        }
                        disabled
                        aria-label="Expiry Date End"
                        placeholder="MM/DD/YYYY"
                      />
                    </div>
                    <DateRangeButton
                      id="expiry"
                      open={expiryDateRangeOpen}
                      setOpen={setExpiryDateRangeOpen}
                    />
                  </div>
                </div>
                {setExpiryDateRangeOpen && (
                  <DateRangeSelect
                    id="expiry"
                    onChange={onDateChange}
                    open={expiryDateRangeOpen}
                    setOpen={setExpiryDateRangeOpen}
                  />
                )}
                {isMobile  && (
                  <span
                    className={`clear-date ${selectedFilters.dateExpiry[0] && selectedFilters.dateExpiry[1] ? '' : 'hidden'}`}
                    onClick={() => applyFiltersDate('dateExpiry', [])}>
                    Clear
                  </span>
                )}
              </div>

              <h4>FDA Approval</h4>
              <div className="filter-group-inner">
                {filters?.statusFdaApproval?.map((filter, idx) => (
                  <div className="fieldset" key={`f-statusFdaApproval-${idx}`}>
                    <input
                      type="checkbox"
                      id={`statusFdaApproval-${filter}`}
                      name={`statusFdaApproval-${filter}`}
                      onChange={() => applyFilters('statusFdaApproval', filter)}
                      checked={selectedFilters.statusFdaApproval.includes(filter)}
                    />
                    <label htmlFor={`statusFdaApproval-${filter}`}>
                      {filter}
                    </label>
                  </div>
                ))}
              </div>

              <h4>Orange/Purple Book</h4>
              <div className="filter-group-inner">
                {filters?.statusOPBook?.map((filter, idx) => (
                  <div className="fieldset" key={`f-statusOPBook-${idx}`}>
                    <input
                      type="checkbox"
                      id={`statusOPBook-${filter}`}
                      name={`statusOPBook-${filter}`}
                      onChange={() => applyFilters('statusOPBook', filter)}
                      checked={selectedFilters.statusOPBook.includes(filter)}
                    />
                    <label htmlFor={`statusOPBook-${filter}`}>
                      {OPBookLabel(filter)}
                      {filter}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="disclaimer">
          <h4>Note on Data Currency</h4>
          <p>The patent landscape data for each drug was completed at different times. Comprehensive patent landscaping was completed as of the following dates:</p>
          <p>May-June 2022: Biktarvy, Eylea, Humira, Revlimid, Trulicity</p>
          <p>July 2024: Mounjaro/Zepbound, Ozempic/Rybelsus/Wegovy</p>
          <p>September-October 2024: Jardiance, Farxiga, Entresto, Eliquis, Enbrel, Imbruvica, Januvia, Stelara, Xarelto</p>
          <p>April-July 2025: Calquence, Darzalex/Darzalex Faspro, Dupixent, Janumet/Janumet XR, Linzess, Opdivo, Pomalyst, Skyrizi, Trelegy Ellipta, Xtandi</p>
          <p>April 2026: Keytruda</p>
        </div>
      </div>

      <div className="container">
        <div className="results-count-heading">
          <p>{resultsLength(patentDataFiltered)}</p>

          {checkedStorage && !showPopup && (
            <a className="download-data" href="https://drugpatentbook.i-mak.org/i-mak-drug-patent-book-20260406.csv" download>
              <IconDownload /> Download full data
            </a>
          )}
        </div>

        <div className="table-wrapper">
          <div className="table-wrapper-inner">
            <table>
              <thead>
                <tr>
                  <th className="sortable drug"
                    onClick={() => setSortBy(['drug', sortBy[1] === 'ASC' ? 'DESC' : 'ASC'])}
                  >
                    <span className="sort drug-sort">
                      <IconSortDynamic sorted={sortBy[0] === 'drug'} dir={(sortBy[0] === 'drug' && sortBy[1]) || ''} />
                    </span>
                    Drug
                  </th>
                  <th className="assignee">Assignee</th>

                  {/* <th className="sortable"
                    onClick={() => setSortBy(['dateFile', (sortBy[1] === 'ASC') ? 'DESC' : 'ASC'])}
                  >
                    <span className="sort">
                      <IconSortDynamic sorted={sortBy[0] === 'dateFile'} dir={(sortBy[0] === 'dateFile') && (sortBy[1] || '')} />
                    </span>
                    Filed
                  </th> */}
                  
                  {/* {<th className="sortable"
                    onClick={() => setSortBy(['dateExpiry', sortBy[1] === 'ASC' ? 'DESC' : 'ASC'])}
                    >
                    <span className="sort">
                      <IconSortDynamic sorted={sortBy[0] === 'dateExpiry'} dir={sortBy[0] === 'dateExpiry' && sortBy[1] || ''} />
                    </span>
                  </th>} */}

                  {isMobile ? (
                   <>
                    <th>Filed</th>
                    <th>Expiry</th>
                   </>
                  ) : (
                    <>
                      <th>Patent/<br />Publication Number</th>
                      <th>Filed</th>
                      <th>Expiry</th>
                      <th>Status</th>
                      <th>Patent Type</th>
                      <th>FDA <br />Approval</th>
                      <th>Orange/<br />Purple Book</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {checkedStorage && !showPopup && patentDataFiltered?.map((data, idx) => (
                  <React.Fragment key={`row-fragment-${data.patentNo}-${idx}`}>
                    <tr key={`tr-${idx}`} className="row-data">
                      <td
                        className={`drug ${expandedRows.includes(idx) && 'expanded'}`}
                        onClick={() => toggleRow(idx)}
                      >
                        <span className="drug-toggle">
                          {expandedRows.includes(idx) ? (
                            <IconChevronUp />
                          ) : (<IconChevronDown />)}
                        </span>
                        {data.drug}
                      </td>
                      <td className="assignee">{data.assignee}</td>
                      {isMobile ? (
                        <>
                          <td className="dateFile">{formatDateTimeToYear(data.dateFile)}</td>
                          <td className="dateExpiry">{formatDateTimeToYear(data.dateExpiry)}</td>
                        </>
                      ) : (
                        <>
                          <td className="patentNo"><a href={data.urlGooglePatents} target="_blank" rel="noreferrer">{data.patentNo}</a></td>
                          <td className="dateFile">{formatDateTime(data.dateFile)}</td>
                          <td className="dateExpiry">{formatDateTime(data.dateExpiry)}</td>
                          <td className="status">{data.status}</td>
                          <td className="patentType">{data.patentType}</td>
                          <td className="fdaApproval">{data.statusFdaApproval}</td>
                          <td className="statusOPBook">{data.statusOPBook ? data.statusOPBook : 'N/A'}</td>
                        </>
                      )}
                    </tr>
                    <tr key={`tr-expandable-${idx}`} className={`tr-expandable ${expandedRows.includes(idx) ? 'expanded' : ''}`}>
                      
                      {isMobile ? (
                        <td colSpan="12">
                          <p><strong>Patent/Publication Number:</strong> <a href={data.urlGooglePatents} target="_blank" rel="noreferrer">{data.patentNo}</a></p>
                          <p><strong>Patent Type:</strong> {data.patentType}</p>
                          <p><strong className="label">Granted/Publication/Reissued Date:</strong> {formatDateTime(data.datePublication)}</p>
                          <div>
                            <p><strong>Status:</strong> {data.status}</p>
                          </div>
                          <div>
                            {data.dateFile && (<p><strong>Date Filed: </strong> {formatDateTime(data.dateFile)}</p>)}
                            {data.dateFile && (<p><strong>Date Expiry: </strong> {formatDateTime(data.dateExpiry)}</p>)}
                          </div>
                          <div>
                            {data.statusOPBook && (<p><strong>Orange/PurpleBook: </strong> {formatDateTime(data.statusOPBook)}</p>)}
                            {data.statusFdaApproval && (<p><strong>FDA Approval: </strong> {formatDateTime(data.statusFdaApproval)}</p>)}
                          </div>
                          <p>{data.description}</p>
                        </td>
                      ) : (
                        <td colSpan="9">
                          <div className="expandable-content">
                            <div className="expandable-content-col">
                              <p><strong className="label">Drug Type:</strong> {data.drugType}</p> 
                              <p><strong className="label">Priority Date:</strong> {formatDateTime(data.datePriority)}</p> 
                            </div>
                            <div className="expandable-content-row">
                              <div className="expandable-content-row">
                                <div className="expandable-content-col">
                                  <p><strong className="label">Condition(s) Treated:</strong> {data.conditionsTreated}</p>
                                  <p><strong className="label">Granted/Publication/Reissued Date:</strong> {formatDateTime(data.datePublication)}</p>
                                </div>
                                <p><strong className="label">Family:</strong> {data.family}</p>
                              </div>
                              
                            </div>
                          </div>
                          <p>{data.description}</p>
                        </td>
                      )}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>

            {!resultsLength(patentDataFiltered) && (
              <div className="no-results">
                <p>No results match your search. Please try again.</p>
                <button
                  className={`btn btn-grey btn-clear ${objectIsEmpty(selectedFilters) && 'hidden'}`}
                  onClick={() => clearFilters()}
                >
                  Clear All Filters
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export { Main }